module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/card-front@2x_2939aa.png";